<template>
  <div>
    <h5>{{ "enter_imie_1" | setText("Введите IMEI 1") }}</h5>
    <imeis :barcode="barcode" @input="setImei" />
    <ul>
      <li v-for="(datum, key) in data" :key="key">
        <fg-input
          type="text"
          :label="datum.title"
          :readonly="true"
          v-mask="`###############`"
          v-model="datum.value"
        />
      </li>
    </ul>
    <button class="btn btn-info mw" @click="apply">
      {{ "apply" | setText("Применить") }}
    </button>
  </div>
</template>
<script>
import List from "../../List.vue";
import Imeis from "./Imeis.vue";
export default {
  components: { Imeis },
  name: "products",
  methods: {
    setImei(val) {
      this.$loading(true);
      this.data = [];

      setTimeout(() => {
        try {
          for (let i = 0; i < val.list.length; i++) {
            this.data.push({
              value: val.list[i].number,
              title: `IMEI ${i + 1}`,
            });
          }
        } catch (error) {}
        this.$loading(false);
      }, 300);
    },
    apply() {
      try {
        // if (!this.data[0].value || !this.data[1].value) {
        //   this.$notify({
        //     title: "IMEI",
        //     message: "Установите IMEI",
        //     icon: "ti-save",
        //     horizontalAlign: "right",
        //     verticalAlign: "top",
        //     type: "warning",
        //   });
        //   return false;
        // } else if (this.data[0].value == this.data[1].value) {
        //   this.$notify({
        //     title: "IMEI",
        //     message: "IMEI 1 и IMEI 2 не должны быть одинаковые",
        //     icon: "ti-save",
        //     horizontalAlign: "right",
        //     verticalAlign: "top",
        //     type: "warning",
        //   });
        //   return false;
        // }
        if (!this.data[0].value) {
          this.$notify({
            title: "IMEI",
            message: "Установите IMEI",
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "warning",
          });
          return false;
        } else if (this.data[0].value == this.data[1].value) {
          this.$notify({
            title: "IMEI",
            message: "IMEI 1 и IMEI 2 не должны быть одинаковые",
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "warning",
          });
          return false;
        }
      } catch (error) {
        this.$notify({
          title: "IMEI",
          message: "Неверные значения у IMEI",
          icon: "ti-save",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "warning",
        });
      }

      let data = [];
      for (let i = 0; i < this.data.length; i++) {
        data[i] = {};
        data[i][this.keyImei] = this.data[i].value;
      }
      this.$emit("input", data);
    },
  },
  props: {
    keyImei: {
      default: "number",
    },
    value: {
      default: function () {
        return [];
      },
    },
    barcode: {
      default: function () {
        return null;
      },
    },
  },
  created() {
    if (this.value.length) {
      this.data = [];
      for (let i = 0; i < this.value.length; i++) {
        this.data.push({
          value: this.value[i][this.keyImei],
          title: `IMEI ${i + 1}`,
        });
      }
    }
  },
  data() {
    return {
      barcodeList: null,
      data: [
        {
          title: "IMEI 1",
          value: "",
        },
        {
          title: "IMEI 2",
          value: "",
        },
      ],
    };
  },
};
</script>